module.exports = __webpack_public_path__ + "assets/img/922188.df3fb185.jpg";